module.exports = __webpack_public_path__ + "media/images/home/flipcard_company-91f22555cbad3e463180519ec1809d03.svg";